import { Component, Input, OnInit } from '@angular/core';
import { getSocialIconClass } from 'app/social/get-social-icon-class';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { SearchActivityEvents } from 'generated/graphql';
import { FeatureFlagService } from 'feature-flags/feature-flag.service';

@Component({
  selector: 'app-contact-info-event',
  templateUrl: './contact-info-event.component.html',
})
export class ASContactInfoEventComponent
  extends WithDisposableSubject() {
  @Input() item: SearchActivityEvents.Node;

  get iconClass() {
    switch (this.item.itemType) {
      case 'PhoneNumber':
        return 'fa-phone';
      case 'Address':
        return 'fa-address-card';
      case 'Email':
        return 'fa-envelope';
      case 'SocialProfile':
        return getSocialIconClass(this.item.payload.socialProfile.socialNetworkType);
      default:
        return 'fa-address-card';
    }
  }
  /**
   *
   */
  constructor(
  ) {
    super();
  }

  getEventDescriptionText(item: SearchActivityEvents.Node) {
    let typeUpdated = this.getEventTagText(item).toLocaleLowerCase();
    const vowelRegex = '^[aieouAIEOU].*';
    const typeUpdatedAnOrA = (typeUpdated.match(vowelRegex)) ? 'an' : 'a';
    typeUpdated = typeUpdatedAnOrA + ' ' + typeUpdated;

    if (item.name.includes('subscribe')) {
      // unsubscribed or subsribed
      return ` ${item.name.split('_')[0]}d ${typeUpdated} for `;
    }

    if (item.name.includes('verified')) {
      return ` confirmed ${typeUpdated} for `;
    }

    if (item.name.includes('bad')) {
      return ` marked ${typeUpdated} as bad for `;
    }

    if (item.name.includes('do_not_contact')) {
      return ` marked ${typeUpdated} as do not contact for `;
    }

    if (item.name.includes('update')) {
      return `updated ${typeUpdated} for `;
    }

    if (item.name.includes('create')) {
      return ` created ${typeUpdated} for `;
    }
  }

  getEventTagText(item: SearchActivityEvents.Node) {
    if (item.name.includes('email')) {
      return `Email (${this.getHomeWorkMobile(item.name)})`;
    }

    if (item.name.includes('phone')) {
      return `Phone (${this.getHomeWorkMobile(item.name)})`;
    }

    if (item.name.includes('address')) {
      return `Address (${this.getPhysicalMailing(item.name)})`;
    }

    if (item.name.includes('social')) {
      return `social media profile (${item.payload.socialProfile.label})`;
    }
  }

  getPayload() {
    if (this.item.itemType === 'PhoneNumber') {
      return this.item.payload['phoneNumber'];
    }
    if (this.item.itemType === 'Email') {
      return this.item.payload['email'];
    }
    if (this.item.itemType === 'Address') {
      return this.item.payload['address'];
    }
    if (this.item.itemType === 'SocialProfile') {
      return this.item.payload['social'];
    }
  }

  getPhysicalMailing(eventName: string) {
    if (eventName.includes('physical')) {
      return 'Physical';
    }
    if (eventName.includes('mailing')) {
      return 'Mailing';
    }
    return 'Physical';
  }

  getHomeWorkMobile(eventName: string) {
    if (eventName.includes('home')) {
      return 'Home';
    }
    if (eventName.includes('cell')) {
      return 'Mobile';
    }
    if (eventName.includes('work')) {
      return 'Work';
    }
    return '';
  }
}
